export function phoneNumberOption(phone: string) {
  if (!phone) {
    return { blocks: [3, 3, 3, 3], delimiter: " " };
  }

  const compactPhone = phone.replace(/\s/g, "");

  if (/^\+61[45]/.test(compactPhone)) {
    return { blocks: [3, 3, 3, 3], delimiter: " " };
  }

  if (/^\+61[1-9]/.test(compactPhone)) {
    return { blocks: [3, 1, 4, 4], delimiter: " " };
  }

  if (/^(?:04|05|1300|1800)/.test(compactPhone)) {
    return { blocks: [4, 3, 3], delimiter: " " };
  }

  return { blocks: [2, 4, 4], delimiter: " " };
}

export const phonePlaceholder = "0412 345 678";

export const getCurrencyOptions = ({
  numeral = true,
  numeralThousandsGroupStyle = "thousand",
  numeralPositiveOnly = true,
}: {
  numeral?: boolean;
  numeralThousandsGroupStyle?: NumeralThousandsGroupStyle;
  numeralPositiveOnly?: boolean;
}): CurrencyOptions => ({
  numeral,
  numeralThousandsGroupStyle,
  numeralPositiveOnly,
  noImmediatePrefix: true,
});
type NumeralThousandsGroupStyle = "thousand" | "lakh" | "wan";

type CurrencyOptions = {
  numeral: boolean;
  numeralThousandsGroupStyle: NumeralThousandsGroupStyle;
  numeralPositiveOnly: boolean;
  noImmediatePrefix: boolean;
};
